import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';
import { Button, Tabs, Row, Col, Modal, Icon, Input, message, Form, Table, LocaleProvider, Select, DatePicker, Radio, Upload } from 'antd';
import "./../style.css";
import { Hcurl, UpLoadedFilesUrl, uploadAction } from "./../../../../../constants/index";//获取公共路径
import $ from "jquery";
const history = createHistory();
let _RegistrationCommon = null;
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
            Commondata: [],
            ci_code: this.props.CaseCI_Code
        }
    }
    componentWillReceiveProps = (props) => {
        if (props.CaseCI_Code != '' && props.CaseCI_Code != undefined) {
            this.setState({
                ci_code: props.CaseCI_Code,
                visible: props.visible
            })
            setTimeout(() => {
                if (_RegistrationCommon.state.visible == true) {
                    _RegistrationCommon.geteditInfo()
                }
            }, 120)
        }
    }

    componentDidMount() {
        _RegistrationCommon = this;
    }
    geteditInfo = () => {
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: Hcurl + "/AF_CompanyCaseInfo/getCaseInfoDetail?ci_code=" + _RegistrationCommon.state.ci_code,
            type: "post",
            headers: {
                "token": token
            },
            success: function (data) {
                if (data != '' && data != null) {
                    data = JSON.parse(data);
                    console.log(data, 'data');
                    _RegistrationCommon.setState({
                        Commondata: data
                    })
                } else {
                    _RegistrationCommon.setState({
                        Commondata: null
                    })
                }

            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }
        })
    }

    handleOk = () => {
        this.setState({
            visible: false
        })
        this.props.isShows(false)
    }
    onCancel = () => {
        this.setState({
            visible: false
        })
        this.props.isShows(false)
    }
    render() {
        const colStyle = { marginTop: 15 }
        return (
            <div>
                <Modal
                    className='RegistrationModal'
                    width='1000px'
                    visible={this.state.visible}
                    onCancel={this.onCancel}
                    title='查看'
                    footer={[
                        <Button key="submit" onClick={this.handleOk} >
                            返回列表
                         </Button>,

                    ]}
                >
                    <div style={{ height: 500 }}>{this.state.Commondata.length != 0 ? <div style={{ height: 500, overflowX: "hidden" }}>
                        <Row gutter={30}>
                            <Col span={8}>
                                <span className='CommonTitle'>申报编号：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_Code}</span>
                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>申报时间：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_RegTime}</span>
                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>申报人：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].JoinMan}</span>
                            </Col>
                            </Row>
                                <Row>
                            <Col span={8} style={colStyle}>
                                <span className='CommonTitle'>申报企业：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].Com_Name}</span>
                            </Col>
                                </Row>
                                <Row style={{ marginTop: 30 }} gutter={30}>
                            <Col span={8}>
                                <span className='CommonTitle'>投诉日期：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_TypeTime}</span>

                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>投诉人姓名：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_UserName}</span>

                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>联系电话：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_UserPhone}</span>
                            </Col>
                            </Row>
                                <Row gutter={30}>
                            <Col span={8} style={colStyle}>
                                <span className='CommonTitle'>商品/服务：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_ShopName}</span>
                            </Col>
                            <Col span={8} style={colStyle}>
                                <span className='CommonTitle'>购货日期：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_EventTime}</span>
                            </Col>
                            </Row>
                            <Row>
                            <Col span={24} style={colStyle}>
                                <span className='CommonTitle'>具体内容：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_Content}</span>
                            </Col>
                        </Row>
                            <Row style={{ marginTop: 30 }} gutter={30}>
                            <Col span={8}>
                                <span className='CommonTitle'>和解结果：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_Result == 0 ? "和解成功" : "和解失败"}</span>

                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>争议金额（元）：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_ShopMoney != null ? (this.state.Commondata[0].CI_ShopMoney).toString().indexOf('.') >= 0 ? this.state.Commondata[0].CI_ShopMoney : this.state.Commondata[0].CI_ShopMoney+'.00':""}</span>

                            </Col>
                            <Col span={8}>
                                <span className='CommonTitle'>退赔金额（元）：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_RedeemLoss != null ? (this.state.Commondata[0].CI_RedeemLoss).toString().indexOf('.') >= 0 ? this.state.Commondata[0].CI_RedeemLoss : this.state.Commondata[0].CI_RedeemLoss + '.00' : ""}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={colStyle}>
                                <span className='CommonTitle'>受理人：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_HanderName}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={colStyle}>
                                <span className='CommonTitle'>处理内容：</span>
                                <span className='CommonTitles'>{this.state.Commondata[0].CI_FeedContent}</span>
                            </Col>
                        </Row></div> : ""}
                    </div>
                </Modal>
            </div>

        )
    }
}
export default App


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyAccord/CompanyRegistration/RegistrationCommon.js